var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React from 'react';
import { jsx } from '@emotion/core';
import { Item } from './item';
import { Legend } from './legend';
import { FONT } from '../../constants';

var Stepper = function Stepper(_a) {
  var children = _a.children,
      _b = _a.activeStep,
      activeStep = _b === void 0 ? 0 : _b;
  var stepsTotal = React.Children.count(children);
  var currentStep = activeStep <= 0 ? 1 : activeStep > stepsTotal ? stepsTotal + 1 : activeStep;
  return jsx("div", {
    role: "group",
    "aria-label": "progress",
    css: __assign({
      fontFamily: FONT.family
    }, FONT.sizes.regular)
  }, jsx("ol", {
    css: {
      margin: 0,
      display: 'inline-flex'
    }
  }, React.Children.map(children, function (child, index) {
    return React.cloneElement(child, {
      index: index,
      activeStep: currentStep
    });
  })), jsx(Legend, {
    activeStep: currentStep,
    stepsTotal: stepsTotal
  }));
};

Stepper.Item = Item;
export default Stepper;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/Stepper/index.js
// module id = 1236
// module chunks = 0